import { ChangeEvent } from 'react';
import { clsx } from 'clsx';

import { Icons } from '../icons';

type TCheckboxProps = {
  id?: string;
  checked: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  dataTestId?: string;
  readOnly?: boolean;
  tabIndex?: 0 | -1;
  required?: boolean;
  name?: string;
  className?: string;
};

export const Checkbox = ({
  id,
  checked,
  onChange,
  dataTestId,
  readOnly,
  tabIndex,
  required,
  name,
  className,
}: TCheckboxProps) => {
  console.log('checked', checked);
  return (
    <label
      data-testid='checkbox'
      htmlFor={id}
      className={clsx('checkbox', className)}
    >
      <input
        id={id}
        data-testid={dataTestId}
        checked={checked}
        type='checkbox'
        className='peer absolute appearance-none opacity-0'
        onChange={onChange}
        readOnly={readOnly}
        tabIndex={tabIndex}
        required={required}
        name={name}
      />
      <span className='checkbox-layout peer-focus-visible:ring-2' />
      <Icons
        icon='checkmark'
        sizeClassName='checkbox-mark-size'
        isInteractive
        className='checkbox-mark duration-100 block peer-checked:opacity-100! absolute'
      />
    </label>
  );
};
